import {Button, Grid, makeStyles, Paper} from "@material-ui/core"
import React, {useEffect} from "react"
import LoadPage from "../../components/LoadPage"
import PageCustom from "../../components/PageCustom"
import PlatformRequest from "../../utils/PlatformRequest"
import ProviderRegisterCompanyInfo from "../ProviderRegister/ProviderRegisterCompanyInfo"
import ProviderRegisterContact from "../ProviderRegister/ProviderRegisterContact"
import StorageService from "../../services/StorageService";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles({
    boxRegister: {
        padding: 40,
    },
})

const ProfilePage = () => {
    const classes = useStyles()
    const history = useHistory();
    const storageService = new StorageService();
    const [load, setLoad] = React.useState(false)
    const [provider, setProvider] = React.useState({
        id: "",
        ssn: "",
        fancyName: "",
        companyName: "",
        phone: null,
        email: null,
        contactTypeList: [],
        nationalityList: [],
        carTypeList: [],
        carPartList: [],
        carBrandList: [],
        segmentList: []
    })
    const [required, setRequired] = React.useState({  // eslint-disable-line
        ssn: false,
        companyName: false,
        fancyName: false,
        carType: false,
        nationality: false,
        part: false,
        phone: false,
        brand: false,
        segment: false
    })
    const [ssnValid, setSsnValid] = React.useState(true) // eslint-disable-line

    useEffect(() => {
        const employee = storageService.getObjectLocalStorage('employee');
        if (employee !== null) {
            history.goBack()
            return
        }
        setLoad(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const loadProvider = (segments, brands) => {
        PlatformRequest.getAuthProvider().then((response) => {
            let {body} = response
            body.segmentList = segments.filter((item) => body.segmentList.includes(item.id))
            body.carBrandList = brands.filter((item) => body.carBrandList.includes(item.id))

            setProvider(body)
            setLoad(false)
        })
    }

    const updateProvider = () => {
        const payload = {
            id: provider.id,
            ssn: provider.ssn.replace(/[^\d]+/g, ''),
            fancyName: provider.fancyName,
            companyName: provider.companyName,
            phone: provider.phone.replace(/[^\d]+/g, ''),
            email: provider.email,
            contactTypeList: provider.contactTypeList,
            nationalityList: provider.nationalityList,
            carTypeList: provider.carTypeList,
            carPartList: provider.carPartList,
            carBrandList: provider.carBrandList.map((item) => item.id),
            segmentList: provider.segmentList.map((item) => item.id)
        }

        setLoad(true)
        return PlatformRequest.updateProvider(provider.id, payload).then(() => {
            setLoad(false)
        })
    }

    return (
        <PageCustom title="Dados Cadastrais">
            <LoadPage load={load}/>

            <Grid container
                  direction="row"
                  spacing={4}
                  justify="space-between"
                  alignItems="baseline">
                <Grid item></Grid>
                <Grid item>
                    <Grid container
                          direction="row"
                          spacing={2}
                          justify="space-between"
                          alignItems="flex-end">

                        <Grid item>
                            <Button onClick={updateProvider} color="primary" variant="contained">Atualizar</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <br/>
            <Grid container
                  direction="row"
                  spacing={2}>
                <Grid item xs={12} lg={6} md={12}>
                    <Paper elevation={3} className={classes.boxRegister}>
                        <ProviderRegisterCompanyInfo
                            provider={provider}
                            ssnDisabled={true}
                            updateProvider={setProvider}
                            required={required}
                            edit={true}
                            loadProvider={loadProvider}
                            validSsn={setSsnValid}/>
                    </Paper>
                </Grid>
                <Grid item xs={12} lg={6} md={12}>
                    <Paper elevetion={3} className={classes.boxRegister}>
                        <ProviderRegisterContact provider={provider} updateProvider={setProvider} required={required}/>
                    </Paper>
                </Grid>
            </Grid>

        </PageCustom>
    )
}

export default ProfilePage
